/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_EyebrowInputs */

const es_landing_how_eyebrow = /** @type {(inputs: Landing_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona`)
};

const gl_landing_how_eyebrow = /** @type {(inputs: Landing_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como funciona`)
};

const en_landing_how_eyebrow = /** @type {(inputs: Landing_How_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Landing_How_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_how_eyebrow = /** @type {((inputs?: Landing_How_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_how_eyebrow(inputs)
	if (locale === "en") return en_landing_how_eyebrow(inputs)
	return es_landing_how_eyebrow(inputs)
});